// extracted by mini-css-extract-plugin
export var copyableItem = "_8-0";
export var underlined = "_8-1";